import InitComponent from "Modules/InitComponent";
import store from "Stores/store";
import StickyCtaFooter from "./components/StickyCtaFooter.vue";

const stickyCtaFooter = document.querySelectorAll(".sticky-cta-footer__app");
const initComponent = new InitComponent({
  components: { StickyCtaFooter },
  selectors: stickyCtaFooter,
  store,
  template: "<StickyCtaFooter />",
});

initComponent.init();
